export default "__VITE_ASSET__DnJqulc___"